import styled from '@emotion/styled';
import rem from '../../utils/rem/rem';

export const Page = styled.div`
  height: calc(100vh - 208px);
  padding: 0 ${rem(32)};
  display: flex;
`;

export const TableWrapper = styled.div`
  flex-grow: 1;
`;

export const ButtonLabel = styled.div`
  font-family: 'Open Sans';
  font-size: ${rem(12)};
  text-transform: uppercase;
  line-height: ${rem(20)};
  color: ${({ theme }) => theme.colors.gray600};
`;

export const Buttons = styled.div`
  flex-shrink: 0;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  button {
    padding: 0 8px;
    min-width: ${rem(160)};
  }
`;

export const ButtonsSeparator = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray400};
  padding-bottom: ${rem(12)}; 
`;

export const RadioWrapper = styled.div`
  padding-top: ${rem(8)};
`;

export const NullMenuSpec = styled.div`
display: flex;
align-items: center;
&:hover {
  background-color: ${({ theme }) => theme.colors.white} !important;
}
`;

export const NullPrompt = styled.div`
margin-left: 10px;
color: #E21216;
font-family: 'Open Sans';
font-style: normal;
font-weight: 400;
font-size: 14px;
line-height: 21px;
&:hover {
  background-color: ${({ theme }) => theme.colors.white} !important;
}
`;

